import _ from "lodash";
import { useMemo, useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { IProps as IBetslipProps } from "../components/betslip";
import upperDataStore from "../stores/upperData";

import DefaultConfig from "../client-config/default.json";
import { IClientConfig } from "../client-config/config";
import mainState from "../stores/main";
import { BetTypeEnum } from "../constants/enums/betType";
import { PriceChangeEnum } from "src/constants/enums/priceChange";

const mergeConfigs = (mainConf: IClientConfig, conf: Partial<IClientConfig>) =>
  _.mergeWith(_.cloneDeep(mainConf), conf, (objValue, srcValue) => {
    if (Array.isArray(objValue) && Array.isArray(srcValue)) return srcValue;
  });

export let translate = null;

export const useUpperDataProvider = ({
  stake,
  balance,
  authData,
  translate,
  config,
  oddsFormat,
  partnerConfig,
  currencyConfig,
  bonusRules,
  userId,
  verificationResolver,
  verificationResponse,
  profitBoostPercent,
  profitBoostStake,
  memberId,
  freeBonuses,
  transformSelection,
}: IBetslipProps) => {
  const setUpperData = useSetRecoilState(upperDataStore);
  const setMainState = useSetRecoilState(mainState);

  const margedConfig = useMemo(
    () => (config ? mergeConfigs(DefaultConfig as IClientConfig, config) : (DefaultConfig as IClientConfig)),
    [config]
  );

  useEffect(() => {
    setUpperData({
      authData,
      userId,
      memberId,
      balance: balance || 0,
      translate: translate || ((str) => str),
      config: margedConfig,
      oddsFormat,
      partnerConfig,
      currencyConfig,
      bonusRules,
      verificationResolver,
      verificationResponse,
      freeBonuses: freeBonuses || [],
      transformSelection: transformSelection || _.identity,
    });
  }, [
    translate,
    margedConfig,
    oddsFormat,
    partnerConfig,
    currencyConfig,
    bonusRules,
    balance,
    authData,
    setUpperData,
    userId,
    memberId,
    verificationResolver,
    verificationResponse,
    transformSelection,
  ]);

  useEffect(() => {
    setMainState(mainState => ({
      ...mainState,
      profitBoostPercent,
      profitBoostStake
    }))
  }, [profitBoostPercent, profitBoostStake])

  useEffect(() => {
    if (stake)
      setMainState((mainState) => ({
        ...mainState,
        stake,
      }));
  }, [stake]);

  useEffect(() => {
    setMainState((mainState) => {
      if (mainState.initialized) return mainState;
      const defaultBetType = margedConfig.defaultBetType as keyof typeof BetTypeEnum;
      const defaultPriceChangeType = margedConfig.defaultPriceChangeType as keyof typeof PriceChangeEnum;

      return {
        ...mainState,
        betType: BetTypeEnum[defaultBetType],
        priceChangeType: PriceChangeEnum[defaultPriceChangeType],
        initialized: true,
      };
    });
  }, [margedConfig, setMainState]);
};
